// extracted by mini-css-extract-plugin
export default {"root":"blog-layout_root__x+I-A"};